import { render } from "./VideoBlock.vue?vue&type=template&id=12a2be56"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/VideoBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12a2be56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12a2be56', __exports__)) {
    api.reload('12a2be56', __exports__)
  }
  
  module.hot.accept("./VideoBlock.vue?vue&type=template&id=12a2be56", () => {
    api.rerender('12a2be56', render)
  })

}


export default __exports__